import request from '@/utils/request'

// 获取收货单状态变更申请主表信息
export function getPurReceivingChange(orderCode) {
  return request({
    url: `/api/srm-finc/purReceivingChange/getDetail/${orderCode}`,
    method: 'get'
  })
}
